import * as React from 'react';
import dynamic from 'next/dynamic';
import { IconProps } from '@mybet/components/Icons';
const EvolutionIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "EvolutionIcon"*/ '@mybet/components/Icons/Evolution'
    )
);
const GamoMatIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "GamoMatIcon"*/ '@mybet/components/Icons/Gamomat'
    )
);
const LegaIcon = dynamic(
  () => import(/* webpackChunkName: "LegaIcon"*/ '@mybet/components/Icons/Lega')
);
const MicroGamingIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "MicroGamingIcon"*/ '@mybet/components/Icons/MicroGaming'
    )
);
const NetentIcon = dynamic(
  () =>
    import(/* webpackChunkName: "NetentIcon"*/ '@mybet/components/Icons/Netent')
);
const NoLimitCityIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "NoLimitCityIcon"*/ '@mybet/components/Icons/NoLimitCity'
    )
);
const NyxGamingIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "NyxGamingIcon"*/ '@mybet/components/Icons/NyxGaming'
    )
);
const PlaynGoIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "PlaynGoIcon"*/ '@mybet/components/Icons/PlaynGo'
    )
);
const PlaysonIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "PlaysonIcon"*/ '@mybet/components/Icons/Playson'
    )
);
const QuickspinIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "QuickspinIcon"*/ '@mybet/components/Icons/Quickspin'
    )
);
const ScientificGamesIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "ScientificGamesIcon"*/ '@mybet/components/Icons/ScientificGames'
    )
);
const StakeLogicIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "StakeLogicIcon"*/ '@mybet/components/Icons/StakeLogic'
    )
);
const YggdrasilIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "YggdrasilIcon"*/ '@mybet/components/Icons/Yggdrasil'
    )
);

enum ThirdPartyIcons {
  evolution = 'evolution',
  gamomat = 'gamomat',
  lega = 'lega',
  microgaming = 'microgaming',
  netent = 'netent',
  nolimitcity = 'nolimitcity',
  nyxgaming = 'nyxgaming',
  playngo = 'playngo',
  playson = 'playson',
  quickspin = 'quickspin',
  scientificgames = 'scientificgames',
  stakelogic = 'stakelogic',
  yggdrasil = 'yggdrasil',
}
export type ThirdPartyIconType = keyof typeof ThirdPartyIcons;
type ThirdPartyIconProps = IconProps & {
  icon: ThirdPartyIconType;
};

const ThirdPartyIcon: React.FC<ThirdPartyIconProps> = (props) => {
  const { icon, ...rest } = props;
  return (
    <>
      {icon === 'evolution' && (
        <EvolutionIcon {...rest} viewBox="0 0 108 32" width={108} />
      )}
      {icon === 'gamomat' && (
        <GamoMatIcon {...rest} viewBox="0 0 119 32" width={119} />
      )}
      {icon === 'lega' && (
        <LegaIcon {...rest} viewBox="0 0 102 32" width={102} />
      )}
      {icon === 'microgaming' && (
        <MicroGamingIcon {...rest} viewBox="0 0 113 32" width={113} />
      )}
      {icon === 'netent' && (
        <NetentIcon {...rest} viewBox="0 0 76 32" width={76} />
      )}
      {icon === 'nolimitcity' && (
        <NoLimitCityIcon {...rest} viewBox="0 0 73 32" width={73} />
      )}
      {icon === 'nyxgaming' && (
        <NyxGamingIcon {...rest} viewBox="0 0 65 32" width={65} />
      )}
      {icon === 'playngo' && (
        <PlaynGoIcon {...rest} viewBox="0 0 77 32" width={77} />
      )}
      {icon === 'playson' && (
        <PlaysonIcon {...rest} viewBox="0 0 104 32" width={104} />
      )}
      {icon === 'quickspin' && (
        <QuickspinIcon {...rest} viewBox="0 0 78 32" width={78} />
      )}
      {icon === 'scientificgames' && (
        <ScientificGamesIcon {...rest} viewBox="0 0 52 32" width={52} />
      )}
      {icon === 'stakelogic' && (
        <StakeLogicIcon {...rest} viewBox="0 0 101 32" width={101} />
      )}
      {icon === 'yggdrasil' && (
        <YggdrasilIcon {...rest} viewBox="0 0 104 32" width={104} />
      )}
    </>
  );
};

export default ThirdPartyIcon;
